import * as actionTypes from "./NotificationType";

const INITIAL_STATE = {
  notificationList: [],
};

const NotificationReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SETNOTIFICATIONLIST:
      return {
        ...state,
        notificationList: action.payload,
      };
    default:
      return state;
  }
};

export default NotificationReducer;
